import axios from 'axios';
import { clearAccessContextStorage } from '../utils/accessControl';

let installed = false;
let pendingRedirectTimeoutId = null;

const REDIRECT_THROTTLE_KEY = 'authRedirectInProgressAt';
const REDIRECT_THROTTLE_WINDOW_MS = 5000;
const REDIRECT_DELAY_MS = 3000;

const shouldThrottleRedirect = () => {
  const raw = sessionStorage.getItem(REDIRECT_THROTTLE_KEY);
  const last = raw ? Number(raw) : 0;
  const now = Date.now();

  if (Number.isFinite(last) && last > 0 && now - last < REDIRECT_THROTTLE_WINDOW_MS) {
    return true;
  }

  sessionStorage.setItem(REDIRECT_THROTTLE_KEY, String(now));
  return false;
};

const clearAuthStorage = () => {
  localStorage.removeItem('token');
  clearAccessContextStorage();
};

const notifyAuthCleared = () => {
  try {
    window.dispatchEvent(new Event('smarttile:auth-cleared'));
  } catch (_) {
    // ignore
  }
};

export const clearAuthRedirectThrottle = () => {
  sessionStorage.removeItem(REDIRECT_THROTTLE_KEY);
  if (pendingRedirectTimeoutId !== null) {
    window.clearTimeout(pendingRedirectTimeoutId);
    pendingRedirectTimeoutId = null;
  }
};

export const installAxiosInterceptors = () => {
  if (installed) return;
  installed = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error && error.response ? error.response.status : null;

      if (status !== 401) {
        return Promise.reject(error);
      }

      // Always clear local auth so the login page cannot bounce back.
      clearAuthStorage();
      notifyAuthCleared();

      const currentPath = window.location && window.location.pathname ? window.location.pathname : '';
      if (currentPath === '/login') {
        return Promise.reject(error);
      }

      const requestUrl = error && error.config ? String(error.config.url || '') : '';
      // Avoid redirect loops if the login endpoint itself returns 401 for some reason.
      if (requestUrl.toLowerCase().includes('/auth/login')) {
        return Promise.reject(error);
      }

      if (!shouldThrottleRedirect()) {
        if (pendingRedirectTimeoutId === null) {
          pendingRedirectTimeoutId = window.setTimeout(() => {
            pendingRedirectTimeoutId = null;
            window.location.replace('/login');
          }, REDIRECT_DELAY_MS);
        }
      }

      return Promise.reject(error);
    }
  );
};
